/**
 * מפתח מתגובת GET/PATCH של /api/agents/me/public-site-pricing-settings
 * למבנה { hotel, flight, vacation_package } בלי למזג עם לוגיקת publicSitePricingCommission
 * (שם יש ברירות מחדל/שדות שטוחים שעלולים לשנות type/value).
 */

const ALLOWED_TYPES = new Set(["fixed", "percent"]);

function toNonNegativeNumber(v) {
  const n = Number(v);
  if (!Number.isFinite(n) || n < 0) return 0;
  return n;
}

/**
 * @param {unknown} node
 * @returns {{ type: 'fixed'|'percent', value: number }}
 */
function coerceCategoryNode(node) {
  if (!node || typeof node !== "object" || Array.isArray(node)) {
    return { type: "fixed", value: 0 };
  }
  const rawType = String(node.type ?? "fixed").trim().toLowerCase();
  const type = ALLOWED_TYPES.has(rawType) ? rawType : "fixed";
  return { type, value: toNonNegativeNumber(node.value) };
}

/**
 * @param {unknown} raw
 * @returns {{ hotel: object, flight: object, vacation_package: object }}
 */
export function mapPublicSitePricingSettingsFromApi(raw) {
  const src = raw && typeof raw === "object" ? raw : {};
  return {
    hotel: coerceCategoryNode(src.hotel),
    flight: coerceCategoryNode(src.flight),
    vacation_package: coerceCategoryNode(src.vacation_package),
  };
}

/**
 * טקסט תצוגה ליד השדה — מה יישמר בפועל.
 */
export function formatCommissionWillSaveAs(type, value) {
  const v = toNonNegativeNumber(value);
  if (type === "percent") {
    return `יישמר כאחוז: ${v}%`;
  }
  return `יישמר כסכום קבוע: ₪${v}`;
}

/**
 * הודעת toast אחרי שמירה מוצלחת.
 */
export function buildPublicSiteCommissionSavedToast(settings) {
  const s = mapPublicSitePricingSettingsFromApi(settings);
  const fmt = (cat) => {
    const { type, value } = cat;
    const v = toNonNegativeNumber(value);
    return type === "percent" ? `${v}%` : `${v}₪`;
  };
  return `נשמר: מלונות ${fmt(s.hotel)}, טיסות ${fmt(s.flight)}, חבילות נופש ${fmt(s.vacation_package)}`;
}
